import React from 'react';
import './NotFound.css';

class NotFound extends React.Component {

    render() {
        return (
            <div className={"col-md-8 offset-md-2"}>
                <div className={"card"}>
                    <div className="card-header">
                        <h1>Survey not found</h1>
                    </div>
                    <div>
                        <p>The survey could not be found.</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default NotFound;
